<template>
  <div class="media-list-container">
    <div class="header-section">
      <h1>媒体列表</h1>
      <div class="actions">
        <el-button type="primary" @click="addMedia">
          添加媒体
        </el-button>
      </div>
    </div>

    <div>
      <el-table :data="mediaList" v-loading="loading" :border="true" :stripe="true">
        <el-table-column type="index" label="编号" width="80" align="center"/>
        <el-table-column prop="mediaName" label="媒体名称" align="center"/>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 编辑弹窗 -->
    <div v-if="showAddMediaDialog" class="dialog-mask">
      <div class="dialog-box">
        <h3>添加媒体</h3>
        <form @submit.prevent="submitEdit">
          <div class="form-group">
            <label>媒体名称：</label>
            <input type="text" v-model="mediaNameInput" required />
          </div>
          <div class="dialog-actions">
            <button type="submit" class="action-btn primary" :disabled="editLoading">{{ editLoading ? '提交中...' : '提交' }}</button>
            <button type="button" class="action-btn" @click="() => {
              showAddMediaDialog = false;
              this.mediaNameInput = '';
            }">取消</button>
          </div>
          <div v-if="editError" class="edit-error">{{ editError }}</div>
          <div v-if="editSuccess" class="edit-success">{{ editSuccess }}</div>
        </form>
      </div>
    </div>

    <!-- 删除确认弹窗 -->
    <div v-if="showDeleteDialog" class="dialog-mask">
      <div class="dialog-box delete-confirm-box">
        <h3>确认删除</h3>
        <div class="delete-confirm-content">确定要删除媒体 <b>{{ deleteTarget.mediaName }}</b> 吗？</div>
        <div class="dialog-actions">
          <button class="action-btn danger" @click="handleDeleteConfirm" :disabled="deleteLoading">{{ deleteLoading ? '删除中...' : '确认' }}</button>
          <button class="action-btn" @click="showDeleteDialog = false">取消</button>
        </div>
        <div v-if="deleteError" class="add-error">{{ deleteError }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MediaList',
  data() {
    return {
      mediaList: [], // 从API获取的数据
      loading: false,
      uploadLoading: false,
      showAddMediaDialog: false,
      editError: '',
      editSuccess: '',
      mediaNameInput: "",
      editLoading: false,
      showDeleteDialog: false,
      deleteError: "",
      deleteLoading: false,
    };
  },
  created() {
    // 获取媒体数据
    this.fetchMediaList();
  },
  methods: {
    async fetchMediaList() {
      this.loading = true;
      try {
        // 调用API获取媒体列表数据
        const response = await axios.get('/api/media');
        
        // 处理数据格式，将name字段转换为mediaName
        if (response.data && Array.isArray(response.data)) {
          this.mediaList = response.data.map(({ name, ...rest }) => ({
            ...rest,
            mediaName: name
          }));
        } else {
          this.mediaList = (response.data.data || []).map(({ name, ...rest }) => ({
            ...rest,
            mediaName: name
          }));
        }
      } catch (error) {
        console.error('获取媒体列表失败:', error);
        this.$message.error('获取媒体列表失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    uploadMedia() {
      this.$refs.fileInput.click();
    },

    addMedia() {
      this.showAddMediaDialog = true;
    },

    async submitEdit() {
      try {
        this.editLoading = true;
        const url = `/api/media/add`;
        const res = await axios.post(url, {name: this.mediaNameInput});
        this.fetchMediaList();
        setTimeout(() => {
          this.showAddMediaDialog = false;
        }, 300);
        console.log(res);
      } catch (e) {
        console.log(e);
      } finally {
        this.mediaNameInput = "";
        this.editLoading = false;
      }
    },

    handleDelete(index, row) {
      this.openDeleteDialog(row);
    },

    openDeleteDialog(msg) {
      console.log(msg);
      this.deleteTarget = msg;
      this.deleteError = '';
      this.showDeleteDialog = true;
    },

    async handleDeleteConfirm() {
      this.deleteError = '';
      this.deleteLoading = true;
      try {
        await axios.delete(`/api/media/${this.deleteTarget.id}`);
        this.showDeleteDialog = false;
        await this.fetchMediaList();
      } catch (e) {
        this.deleteError = '删除失败，请稍后重试';
      } finally {
        this.deleteLoading = false;
      }
      console.log(this.deleteLoading);
    },

  }
};
</script>

<style scoped>
.media-list-container {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-section h1 {
  font-size: 24px;
  color: #1e293b;
  margin: 0;
}

.actions {
  display: flex;
  gap: 10px;
}

.actions {
  justify-content: center;
}

.actions .action-btn {
  width: 100%;
  justify-content: center;
}

.action-btn {
  background-color: #fff;
  color: #444;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.action-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}

.action-btn.primary {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
}
.action-btn.primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
  color: white;
}

.action-btn:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.action-btn.danger {
  background-color: #fff1f0;
  color: #f5222d;
  border-color: #ffa39e;
}
.action-btn.danger:hover {
  background-color: #ffccc7;
  color: #a8071a;
  border-color: #ff7875;
}

.dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-box {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  padding: 32px 28px 24px 28px;
  min-width: 320px;
  max-width: 90vw;
}
.dialog-box h3 {
  margin: 0 0 18px 0;
  font-size: 20px;
  color: #333;
  text-align: center;
}

.form-group {
  margin-bottom: 18px;
}
.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #333;
  font-size: 15px;
}
.form-group input, .form-group select, .form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
  border-color: #1890ff;
  outline: none;
}

.edit-error {
  color: #ff4d4f;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}
.edit-success {
  color: #52c41a;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}

.dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 10px;
}
</style>